import { render, staticRenderFns } from "./index.vue?vue&type=template&id=71397724&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=71397724&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71397724",
  null
  
)

export default component.exports